import { render, staticRenderFns } from "./followupStepsTable.vue?vue&type=template&id=7a33899e"
import script from "./followupStepsTable.vue?vue&type=script&lang=js"
export * from "./followupStepsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports